// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var MM_api = require("./MM_api.res.js");
var Core__Option = require("@rescript/core/src/Core__Option.res.js");
var Raw_js_utils = require("../utils/Raw_js_utils.res.js");
var Belt_HashMapString = require("rescript/lib/js/belt_HashMapString.js");

var macroModules = Belt_HashMapString.make(4);

function apiRegisterMacroModule(params) {
  var params$1 = MM_api.apiInputToObjExn(params, "apiRegisterMacroModule: got empty parameters.");
  var moduleName = Raw_js_utils.reqStrExn(params$1.moduleName, "'moduleName' must be a string.");
  var macros = Raw_js_utils.reqArrExn(params$1.macros, "'macros' must be an array.").map(function (macroObj) {
        return {
                name: Raw_js_utils.reqStrExn(macroObj.name, "'name' attribute of a macro must be a string."),
                run: Raw_js_utils.reqFuncExn(macroObj.run, "'run' attribute of a macro must be a function.")
              };
      });
  Belt_HashMapString.set(macroModules, moduleName, macros);
  return Promise.resolve({
              TAG: "Ok",
              _0: undefined
            });
}

function unregisterMacroModule(moduleName) {
  Belt_HashMapString.remove(macroModules, moduleName);
}

function apiUnregisterMacroModule(params) {
  var params$1 = MM_api.apiInputToObjExn(params, "apiUnregisterMacroModule: got empty parameters.");
  var moduleName = Raw_js_utils.reqStrExn(params$1.moduleName, "'moduleName' must be a string.");
  unregisterMacroModule(moduleName);
  return Promise.resolve({
              TAG: "Ok",
              _0: undefined
            });
}

function listRegisteredMacroModules() {
  return Belt_HashMapString.keysToArray(macroModules);
}

function apiListRegisteredMacroModules() {
  return Promise.resolve({
              TAG: "Ok",
              _0: listRegisteredMacroModules().map(function (__x) {
                    return __x;
                  })
            });
}

function listRegisteredMacrosInModule(moduleName) {
  return Core__Option.map(Belt_HashMapString.get(macroModules, moduleName), (function (macros) {
                return macros.map(function (macro) {
                            return macro.name;
                          });
              }));
}

function apiListRegisteredMacrosInModule(params) {
  var params$1 = MM_api.apiInputToObjExn(params, "apiListRegisteredMacrosInModule: got empty parameters.");
  var moduleName = Raw_js_utils.reqStrExn(params$1.moduleName, "'moduleName' must be a string.");
  var arr = listRegisteredMacrosInModule(moduleName);
  var macroNames = arr !== undefined ? arr : [];
  return Promise.resolve({
              TAG: "Ok",
              _0: macroNames.map(function (__x) {
                    return __x;
                  })
            });
}

function runMacro(moduleName, macroName) {
  var macros = Belt_HashMapString.get(macroModules, moduleName);
  if (macros === undefined) {
    return Promise.resolve({
                TAG: "Error",
                _0: "Cannot find a macro module with name \"" + moduleName + "\""
              });
  }
  var macro = macros.find(function (macro) {
        return macro.name === macroName;
      });
  if (macro !== undefined) {
    return macro.run().then(function () {
                return {
                        TAG: "Ok",
                        _0: undefined
                      };
              });
  } else {
    return Promise.resolve({
                TAG: "Error",
                _0: "Cannot find a macro with name \"" + macroName + "\" in the module \"" + moduleName + "\""
              });
  }
}

function apiRunMacro(params) {
  var params$1 = MM_api.apiInputToObjExn(params, "apiRunMacro: got empty parameters.");
  var moduleName = Raw_js_utils.reqStrExn(params$1.moduleName, "'moduleName' must be a string.");
  var macroName = Raw_js_utils.reqStrExn(params$1.macroName, "'macroName' must be a string.");
  return runMacro(moduleName, macroName);
}

function initMacroApi() {
  MM_api.setMacroApi({
        registerMacroModule: MM_api.makeApiFunc("macro.registerMacroModule", apiRegisterMacroModule),
        unregisterMacroModule: MM_api.makeApiFunc("macro.unregisterMacroModule", apiUnregisterMacroModule),
        listRegisteredMacroModules: MM_api.makeApiFunc("macro.listRegisteredMacroModules", (function (param) {
                return apiListRegisteredMacroModules();
              })),
        listRegisteredMacrosInModule: MM_api.makeApiFunc("macro.listRegisteredMacrosInModule", apiListRegisteredMacrosInModule),
        runMacro: MM_api.makeApiFunc("macro.runMacro", apiRunMacro)
      });
}

exports.initMacroApi = initMacroApi;
exports.unregisterMacroModule = unregisterMacroModule;
exports.listRegisteredMacroModules = listRegisteredMacroModules;
exports.listRegisteredMacrosInModule = listRegisteredMacrosInModule;
exports.runMacro = runMacro;
/* macroModules Not a pure module */
